import { Col } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setExprirySetting } from "../../store/slice/expirySettingSlice";
import {
  ExpirySettingRow,
  ExpirySquareOffRow,
  Label,
  NewPositionRow,
} from "./style";
import { optionDays, options } from "../../Helper/constant";
import ThemeDropDown from "../../components/ThemeDropDown";
import ThemeCard from "../../components/ThemeCard";
import React from "react";

const NseFutureRender = ({ tab }) => {
  const dispatch = useDispatch();

  // redux
  const expiryValue = useSelector((state) => state.expirySettingSlice[tab]);

  // function
  const handleChange = (name, selectedValue, selectedOptions) => {
    switch (name) {
      case "SquareOffRate":
        dispatch(
          setExprirySetting({
            key: "SquareOffRate",
            value: selectedValue[0],
            tab: tab,
            parent_key: "intraday",
          })
        );
        break;
      case "rate":
      case "dayBefore":
        dispatch(
          setExprirySetting({
            key: [name],
            value: selectedValue[0],
            tab: tab,
            parent_key: "position",
            nested_key: "expirySquareOffRateAndDayBefore",
          })
        );
        break;
      case "valanEndingSquareOffRate":
      case "newPositionStartBeforeDay":
        dispatch(
          setExprirySetting({
            key: [name],
            value: selectedValue[0],
            tab: tab,
            parent_key: "position",
          })
        );
        break;
      default:
        setExprirySetting({
          key: [name],
          value: selectedValue[0],
          tab: tab,
        });
        break;
    }
  };

  // const handleChange1 = (name, selectedValue, selectedOptions) => {
  //   if (name === "SquareOffRate") {
  //     dispatch(
  //       setExprirySetting({
  //         key: "SquareOffRate",
  //         value: selectedValue[0],
  //         tab: tab,
  //         parent_key: "intraday",
  //       })
  //     );
  //   } else if (name === "rate" || name === "dayBefore") {
  //     dispatch(
  //       setExprirySetting({
  //         key: [name],
  //         value: selectedValue[0],
  //         tab: tab,
  //         parent_key: "position",
  //         nested_key: "expirySquareOffRateAndDayBefore",
  //       })
  //     );
  //   } else if (
  //     name === "valanEndingSquareOffRate" ||
  //     name === "newPositionStartBeforeDay"
  //   ) {
  //     dispatch(
  //       setExprirySetting({
  //         key: [name],
  //         value: selectedValue[0],
  //         tab: tab,
  //         parent_key: "position",
  //       })
  //     );
  //   } else {
  //     setExprirySetting({
  //       key: [name],
  //       value: selectedValue[0],
  //       tab: tab,
  //     });
  //   }
  // };

  return (
    <>
      <ThemeCard title="INTRADAY" bordered={false}>
        <ExpirySettingRow>
          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <Label>Intraday Square-Off Rate</Label>
          </Col>
          <Col xs={24} sm={12} md={6} lg={5} xl={4}>
            <ThemeDropDown
              placeholder="Quotation Rate"
              name="SquareOffRate"
              width={"98%"}
              options={options.user.Expiry.MCX_OPTION}
              $onChange={handleChange}
              $value={expiryValue?.intraday?.SquareOffRate}
            />
          </Col>
        </ExpirySettingRow>
      </ThemeCard>
      <ThemeCard
        title="POSITION"
        bordered={false}
        style={{ marginTop: "2rem" }}
      >
        <ExpirySquareOffRow gutter={[10, 10]}>
          <Col xs={24} sm={24} md={12} lg={10} xl={6}>
            <Label>Expiry Square-Off Rate And Day Before</Label>
          </Col>
          <Col xs={12} sm={12} md={6} lg={5} xl={4}>
            <ThemeDropDown
              placeholder="Quotation Rate"
              name="rate"
              width={"98%"}
              options={options.user.Expiry.MCX_OPTION}
              $onChange={handleChange}
              $value={
                expiryValue?.position?.expirySquareOffRateAndDayBefore?.rate
              }
            />
          </Col>
          <Col xs={12} sm={12} md={6} lg={5} xl={4}>
            <ThemeDropDown
              placeholder="Select Days"
              name="dayBefore"
              width={"98%"}
              options={optionDays.slice(0, 31)}
              $onChange={handleChange}
              $value={
                expiryValue?.position?.expirySquareOffRateAndDayBefore
                  ?.dayBefore
              }
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={10} xl={5}>
            <Label>Valan Ending Square-Off Rate </Label>
          </Col>
          <Col xs={24} sm={12} md={6} lg={5} xl={4}>
            <ThemeDropDown
              placeholder="Closing Rate"
              name="valanEndingSquareOffRate"
              width={"98%"}
              options={options.user.Expiry.MCX_OPTION}
              $onChange={handleChange}
              $value={expiryValue?.position?.valanEndingSquareOffRate}
            />
          </Col>
        </ExpirySquareOffRow>
        <NewPositionRow>
          <Col xs={24} sm={24} md={12} lg={10} xl={6}>
            <Label>New Position Start Before Day</Label>
          </Col>
          <Col xs={24} sm={12} md={6} lg={5} xl={4}>
            <ThemeDropDown
              placeholder="Select Days"
              name="newPositionStartBeforeDay"
              width={"98%"}
              options={optionDays.slice(0, 41)}
              $onChange={handleChange}
              $value={expiryValue?.position?.newPositionStartBeforeDay}
            />
          </Col>
        </NewPositionRow>
      </ThemeCard>
    </>
  );
};

export default React.memo(NseFutureRender);
